<template>
  <div class="dataImage pc" v-empty="empty" :empty-text="emptyText">
    <div class="header">
      <div class="header-left" @click="goHome"></div>
      <div class="header-right">
        <div class="s-painting" @click="showPainting" v-if="auth">
          <span class="logo"></span>
          <span class="text">{{  $t('114') }}</span>
        </div>
        <div class="s-suggest" @click="showModal" v-if="isIfind">
          {{ suggesText }}
        </div>
        <search :data="value" :collect="false" />
        <div class="myCollect" @click="goCollect">
          <div class="icon"></div>
          <div class="text">{{ $t('975ff67ee1') }}</div>
        </div>
      </div>
    </div>
    <div class="group-wrapper" :style="{'box-shadow': isScroll ? '0px 4px 8px 0px rgba(71,71,98,0.08)' : ''}">
      <group-swiper :data="groups" :index="selectGroup" :isMobile="false" ref="group"></group-swiper>
    </div>
    <div class="container" id="imgList" @scroll="handleScroll" ref="scroll">
      <imgList key="home" :data="data" :collect="false" :loadDistance="300" v-if="show" :top="top" :content="value" />
    </div>
    <div class="backTop" @click="backTop" v-if="showBackTop"></div>
    <a-modal v-model:visible="visible" :title="suggesText" :width="900"  @cancel="handleCancel" :footer="false">
      <iframe width="900" height="600" src="https://vote.10jqka.com.cn/webvote/route/310eddf5b1373ddfadce970c2cb9f890" frameborder="0"></iframe>
    </a-modal>
  </div>
</template>
<script>
import search from '@/components/pc/search';
import imgList from '@/components/pc/imgList';
import groupSwiper from '@/components/groupSwiper';
import { throttle, uniqueArr, getCookie } from '@/common';
import {
  getList,
  getCollect,
  collect,
  getTypeList,
  download,
  getAuth
} from '@/api/apiList';
import demo from '@/assets/images/demo/1@2x.png';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      showDetailInfo: false,
      showPreview: false,
      showBackTop: false,
      empty: '',
      emptyText: $t('d12f75264c'),
      suggesText: `${$t('0cd025fa')}，${$t('12822ccb')}！`,
      data: [],
      detailData: null,
      //详情页id
      id: 0,
      //首页滚动加载id
      homeId: '',
      //收藏滚动加载id
      homeFinish: '',
      //首页的搜索框内容
      value: '',
      //收藏的搜索框内容
      show: true,
      isScroll: false,
      top: 0,
      type: 1,
      page: 20,
      handleScroll: () => {},
      selectGroup: 0,
      groups: [],
      visible: false,
      //是否是白名单用户
      auth: false,
      isIfind: false
    };
  },
  provide() {
    return {
      group: () => this.groups[this.selectGroup]?.id || 0,
    };
  },
  components: {
    search,
    imgList,
    groupSwiper,
  },
  beforeRouteEnter(to, from, next) {
    if (from.path.includes('/dataDetail')) {
      next(vm => {
        // vm.value = '';
        // vm.data = [];
        // vm.show = false;
        // vm.page = 20;
        // vm.showDetailInfo = false;
        // vm.homeFinish = false;
        // vm.homeId = '';
        vm.$nextTick(() => {
          // vm.show = true;
          vm.$refs.scroll.scrollTop = vm.top;
          vm.getData();
        });
      });
    } else {
      next(vm => {
        vm.value = '';
        vm.data = [];
        vm.show = false;
        vm.page = 20;
        vm.showDetailInfo = false;
        vm.selectGroup = vm.$route.query.type || '';
        vm.$nextTick(() => {
          vm.show = true;
          vm.renderView(true);
        });
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    next(vm => {
      vm.showDetailInfo = false;
    });
  },
  watch: {
    data(newValue, oldValue) {
      if (newValue.length == 0) {
        this.empty = 'data';
        this.emptyText = $t('d12f75264c');
      }
    },
    collect(newValue, oldValue) {
      if (newValue) {
        let index = this.data.findIndex(d => d.id == newValue.id);
        if (index > -1) {
          this.data[index].collectStatus = newValue.action;
          console.log(this.data[index].title, this.data[index].collectStatus);
        }
      }
    },
  },
  computed: {
    ...mapState(['collect']),
  },
  methods: {
    showPainting(){
      this.$WinAPI('OnClientCmd', ['main=ProPertyTrade&sub=AIPainting',]);
    },
    showModal(){
      this.visible = true
      // window.API.use("OnDispOpenSubUrlV1",["https://vote.10jqka.com.cn/webvote/route/310eddf5b1373ddfadce970c2cb9f890", 1000, 800, 64])
    },
    scroll(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      console.log(scrollHeight - scrollTop - clientHeight, new Date());
      if (scrollHeight - scrollTop - clientHeight < 500) {
        this.renderView();
      }
    },
    scroll2(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      let top = scrollTop;
      this.top = top > 0 ? top : this.top;
      this.isScroll = top > 0;
      this.showBackTop = top > 100;
      console.log('home scroll', top);
    },
    goHome() {
      this.page = 20;
      this.value = '';
      this.data = [];
      this.show = false;
      (this.selectGroup = ''),
        this.$nextTick(() => {
          this.show = true;
          this.renderView(true);
        });
    },
    goCollect() {
      this.$router.push('/dataCollect');
    },
    backTop() {
      this.$refs.scroll.scrollTop = 0;
    },
    async downImg(item) {
      this.$Talog({
        id: 'iFinD_news_tssj_tupian.xiazai',
      });
      this.$Talog({
        id: 'iFinD_appStore_tssj_pc_download',
        platform: window.source,
        img_id: item.id,
      });
      this.$Talog({
          id: 'iFinD_appStore_tssj_pc_download_' + window.source,
          platform: window.source,
          img_id: this.data.id,
      });
      if (getCookie('jgbsessid')) {
        let url = location.protocol + item.url;
        let href = `ifind://!command=down&filename=${item.title}.jpg&valuectrl=1&url=${url}`;
        location.href = href;
      } else {
        let img = new Image();
        img.setAttribute('crossOrigin', 'Anonymous');
        img.onload = function () {
          let canvas = document.createElement('canvas');
          let context = canvas.getContext('2d');
          canvas.width = img.width;
          canvas.height = img.height;
          context.drawImage(img, 0, 0, img.width, img.height);
          canvas.toBlob(blob => {
            let thumbnailUrl = item.thumbnailUrl.split('.');
            const type = thumbnailUrl[thumbnailUrl.length - 1];
            const link = document.createElement('a')
            link.download = `${item.title}.${type}`;
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
          });
        };
        img.src = item.thumbnailUrl + '?v=' + Date.now();
      }
    },
    async doCollect() {
      let i = this.data.findIndex(d => d.id == this.id);
      let collectStatus = Number(!this.data[i].collectStatus);
      let res = await collect({
        id: +this.data[i].id,
        action: collectStatus,
      });
      if (res && res.code === 1) {
        this.data[i].collectStatus = collectStatus;
        // this.$refs.detail.data.collectStatus = collectStatus;
        if (this.data[i].collectStatus) {
          this.$message.success($t('f62827f0c4'));
          this.$Talog({
            id: 'iFinD_news_tssj_tupian.shoucang',
          });
          setTimeout(() => {
            this.$Talog({
              id: 'iFinD_appStore_tssj_pc_favour',
              img_id: this.data[i].id,
            });
          }, 500);
        } else {
          this.data[i].collectNum =
            this.data[i].collectNum - 1 < 0 ? 0 : this.data[i].collectNum - 1;
          this.$message.success($t('cb0f88686e'));
          this.$Talog({
            id: 'iFinD_news_tssj_tupian.quxiaoshoucang',
          });
        }
      } else {
        if (res === 401) {
          this.$message.error($t('66ef92bbe5'));
        } else {
          this.$message.error($t('0b6d2219c6'));
        }
      }
    },
    async getData() {
      let group = this.groups[this.selectGroup]
      if (!this.homeFinish) {
        let res = await getList({
          id: this.homeId,
          pageSize: this.page,
          content: this.value,
          needCollect: 1,
          tagType: group?.id,
        }).catch(error => {
          this.empty = 'error';
          this.emptyText = $t('866b795eae');
        });
        if (res && res.code === 1) {
          this.page = 10;
          let { data } = res;
          if (data) {
            if (data.length == 0) {
              this.homeFinish = true;
              return;
            }
            this.data = uniqueArr(this.data.concat(data));
            //更新滚动所需要的参数
            this.homeId = data[data.length - 1].id;
            this.empty = '';
          } else {
            this.data = [];
          }
        } else {
          this.empty = 'error';
          this.emptyText = $t('866b795eae');
        }
      }
    },
    async getGroup() {
      let res = await getTypeList().catch(error => {
        this.empty = 'error';
        this.emptyText = $t('866b795eae');
      });
      if (res && res.code === 1) {
        this.groups = res.data;
        this.groups.unshift({
          id: '',
          isHot: false,
          name: $t('8818d4830d'),
        });
        // this.selectGroup = res.data[0].id;
        this.homeFinish = false;
        this.homeId = '';
        this.data = [];
        this.getData();
      }
    },
    async handleAuth() {
      let res = await getAuth()
      if (res && res.code === 1) {
        this.auth = res.data
      }
    },
    renderView(isInit = false) {
      if (isInit) {
        this.homeFinish = false;
        this.homeId = '';
        this.data = [];
        this.getGroup();
      } else {
        this.getData();
      }
    },
    handleCancel(){
      this.visible= false;
    }
  },
  created() {
    this.handleScroll = throttle(this.scroll, 1000);
    document.body.style.minWidth = '1366px';
  },
  mounted() {
    this.isIfind = getCookie('jgbsessid')
    this.handleAuth()
    this.$Bus.$on('collect', () => {
      this.doCollect();
    });
    // this.$Bus.$on('loadMore', () => {
    //   this.renderView();
    // });
    this.$Bus.$on('search', val => {
      this.$Talog({
        id: 'iFinD_news_tssj.sousuo',
      });
      this.page = 20;
      this.data = [];
      this.show = false;
      this.homeId = '';
      this.homeFinish = false;
      this.$nextTick(() => {
        this.show = true;
        this.value = val;
        this.renderView();
      });
    });
    this.$Bus.$on('downImg', item => {
      this.downImg(item);
    });
    this.$Bus.$on('changeGroup', (index, id) => {
      this.$Talog({
        id: `iFinD_news_tssj_tab.click.${id}`,
      });
      setTimeout(() => {
        this.$Talog({
          id: `iFinD_appStore_tssj_tab.click.${id}`,
          img_id: id,
        });
      }, 500);

      this.data = [];
      this.show = false;
      this.page = 20;
      this.selectGroup = index + '';
      this.homeFinish = false;
      this.homeId = '';
      this.$nextTick(() => {
        this.show = true;
        this.renderView();
      });
    });
    const {source} = window
    this.$Talog({
      id: 'iFinD_appStore_tssj_pc',
      platform: source,
    });

    this.$Talog({
      id: 'iFinD_appStore_tssj_pc_' + source,
      platform: source,
    });
    const scrollview = this.$refs['scroll'];
    // 移除监听
    scrollview.addEventListener('scroll', this.scroll2, true);
  },
  beforeDestroy() {
    // 获取指定元素
    const scrollview = this.$refs['scroll'];
    // 移除监听
    scrollview.removeEventListener('scroll', this.scroll2, true);
  },
};
</script>
<style lang="less" scoped>
.dataImage {
  min-width: 1366px;
  padding-top: 128px;
  height: 100%;
}
.header {
  width: 100%;
  height: 64px;
  background: #ffffff;
  position: absolute;
  top: 0;
  border-bottom: 1px solid #ececf7;
  z-index: 999;
  min-width: 1366px;
  .header-left {
    width: 144px;
    height: 40px;
    background: url(~@/assets/images/logoWithText.svg) no-repeat 100% 100%;
    position: relative;
    left: 32px;
    top: 12px;
    cursor: pointer;
  }
  .header-right {
    position: absolute;
    right: 34px;
    height: 36px;
    top: 14px;
    display: flex;
    align-items: center;
    .s-painting {
      height: 36px;
      padding: 8px 12px 8px 14px;
      border-radius: 26px;
      font-size: 14px;
      color: #FFFFFF;
      background: url(~@/assets/images/AI-button.svg) 100% 100% no-repeat;
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: 300ms;
      &:hover {
        box-shadow: 0 4px 8px 0 rgba(0,26,75,0.16);
        transform: translateY(-2px);
        transition: 300ms;
      }
      .text {
        font-weight: 700
      }
      .logo {
        width: 16px;
        height: 16px;
        margin-right: 4px;
        background: url(~@/assets/images/icon-AI.svg);
        display: inline-block;
      }
    }
    .s-suggest {
      padding: 8px 8px 8px 12px;
      font-family: MicrosoftYaHei-Bold;
      font-size: 14px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      font-weight: 700;
      background: url(~@/assets/images/s-button.png);
      background-size: cover;
      background-position: center;
      margin-left: 20px;
      margin-right: 24px;
      border-radius: 26px;
      transition: 300ms;
      cursor: pointer;
      &:hover {
        box-shadow: 0 4px 8px 0 rgba(0,26,75,0.16);
        transform: translateY(-2px);
        transition: 300ms;
      }
    }
    .myCollect {
      margin-left: 24px;
      display: flex;
      align-items: center;
      .icon {
        width: 20px;
        height: 20px;
        background: url(~@/assets/images/collect-pc.svg) no-repeat 100% 100%;
        margin-right: 6px;
        margin-top: 3px;
      }
      .text {
        font-family: MicrosoftYaHei-Bold;
        font-size: 18px;
        color: #272841;
        letter-spacing: 0;
        text-align: right;
        font-weight: 700;
      }
      &:hover .text {
        color: #1b63d9;
      }
      &:hover .icon {
        background: url(~@/assets/images/collect-pc-hover.svg) no-repeat 100%
          100%;
      }
      cursor: pointer;
    }
  }
}
.group-wrapper {
  width: 100%;
  position: absolute;
  top: 64px;
  padding: 20px 42px 0;
}
#imgList {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 24px;
}
.backTop {
  width: 48px;
  height: 48px;
  background: url(~@/assets/images/backTop.svg) no-repeat 100% 100%;
  position: fixed;
  right: 32px;
  bottom: 32px;
  cursor: pointer;
  z-index: 999;
  &:hover {
    background: url(~@/assets/images/backTop_hover.svg) no-repeat 100% 100%;
  }
}
.hideList {
  height: calc(100vh - 64px);
  overflow: hidden;
}
</style>
